import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'lib-schedule-payment-button',
  templateUrl: './schedule-payment-button.component.html',
  styleUrls: ['./schedule-payment-button.component.scss']
})
export class SchedulePaymentButtonComponent implements OnInit {

  @Input() tooltip: string = ""
  @Input() disable: boolean = true
  @Input() textBtn: string = "Continuar"

  @Output() onSchedulePayment: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onClickEvent(args?: any) {
    this.onSchedulePayment.emit(args)
  }
}
